import {ValidatorFn} from '@angular/forms';
import {conditionalValidator} from './conditional.validator';
import {dateValidator} from './date.validator';
import {maxLengthValidator} from './max-length.validator';
import {minDateValidator} from './min-date.validator';
import {minLengthValidator} from './min-length.validator';
import {patternValidator} from './pattern.validator';
import {requiredValidator} from './required.validator';
import {requiredTrueValidator} from './required-true.validator';
import {conditionTrueValidator} from './condition-true.validator';
import {maxValueValidator} from './max-value.validator';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

export type BooleanFn = () => boolean;

@Injectable()
export class ValidatorService {

  constructor(private readonly translateService: TranslateService) {
  }

  public required(message?: string): ValidatorFn {
    return requiredValidator(this.getMessageOrDefault('UTILS.VALIDATION.REQUIRED_DEFAULT', message));
  }

  public requiredTrue(message?: string): ValidatorFn {
    return requiredTrueValidator(this.getMessageOrDefault('UTILS.VALIDATION.REQUIRED_TRUE_DEFAULT', message));
  }

  public maxLength(maxLength: number, message?: string): ValidatorFn {
    return maxLengthValidator(maxLength, this.getMessageOrDefault('UTILS.VALIDATION.MAX_LENGTH_DEFAULT', message, {maxLength}));
  }

  public minLength(minLength: number, message?: string): ValidatorFn {
    return minLengthValidator(minLength, this.getMessageOrDefault('UTILS.VALIDATION.MIN_LENGTH_DEFAULT', message, {minLength}));
  }

  public pattern(pattern: string | RegExp, message?: string): ValidatorFn {
    return patternValidator(pattern, this.getMessageOrDefault('UTILS.VALIDATION.PATTERN_DEFAULT', message));
  }

  public conditionalValidator(predicate: BooleanFn, validator: ValidatorFn): ValidatorFn {
    return conditionalValidator(predicate, validator);
  }

  public date(message?: string): ValidatorFn {
    return dateValidator(
      this.getMessageOrDefault('UTILS.VALIDATION.DATE_DEFAULT', message),
      this.translateService);
  }

  public minDate(minDate: string, message?: string): ValidatorFn {
    return minDateValidator(minDate, this.getMessageOrDefault('UTILS.VALIDATION.MIN_DATE_DEFAULT', message, {minDate}));
  }

  public conditionTrue(predicate: BooleanFn, message?: string): ValidatorFn {
    return conditionTrueValidator(predicate, this.getMessageOrDefault('UTILS.VALIDATION.CONDITION_TRUE_DEFAULT', message));
  }

  public maxValue(maxValue: number, message?: string): ValidatorFn {
    return maxValueValidator(maxValue, this.getMessageOrDefault('UTILS.VALIDATION.MAX_VALUE_DEFAULT', message));
  }

  private getMessageOrDefault(defaultMessageKey: string, message?: string, interpolateParams?: Record<string, unknown>): string {
    return message ? message : this.translateService.instant(defaultMessageKey, interpolateParams);
  }
}
